interface AuthConfig {
  headers?: {
    Authorization: string;
  };
}

export function getAuthHeader(token: string | null | undefined): AuthConfig {
  return token
    ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    : {};
}
